import React from "react";
import { Box, Button } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Favorite as FavoriteIcon } from "../icons";
import { FavoriteBorder as FavoriteBorderIcon } from "../icons";
import { T } from "../routes/Translate";
import { brandColors } from "../theme";

// "Me Interesa" / "Te Interesa" de ofertas y eventos (feed y perfil): un solo
// botón para que se vean iguales en todos lados. Usa "accent" y no "primary"
// porque el azul marino/negro de primary no se distingue sobre los fondos de
// los modos oscuros (borde invisible, botón marcado casi igual al fondo).
// Marcado: fondo accent con texto oscuro en modos oscuros y blanco en claro
// (accent es oscuro ahí); sin marcar: contorno y texto accent.
const InterestButton = ({ liked, count, onClick, disabled, sx }) => {
  const filledText = brandColors.mode === "light" ? "#ffffff" : brandColors.primary;

  return (
    <Button
      fullWidth
      variant={liked ? "contained" : "outlined"}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={!!liked}
      startIcon={liked ? <FavoriteIcon /> : <FavoriteBorderIcon />}
      sx={{
        textTransform: "none",
        borderRadius: "6px",
        padding: "8px 14px",
        fontWeight: 600,
        fontSize: "0.9rem",
        boxShadow: "none",
        mt: 1,
        mb: 1,
        transition: "background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease",
        backgroundColor: liked ? brandColors.accent : "transparent",
        color: liked ? filledText : brandColors.accent,
        border: `1px solid ${brandColors.accent}`,
        "&:hover": {
          boxShadow: "none",
          border: `1px solid ${brandColors.accent}`,
          backgroundColor: liked ? alpha(brandColors.accent, 0.85) : alpha(brandColors.accent, 0.12),
        },
        "&.Mui-disabled": {
          color: brandColors.textSecondary,
          borderColor: brandColors.divider,
          backgroundColor: "transparent",
        },
        ...sx,
      }}
    >
      {liked ? <T>Te Interesa</T> : <T>Me Interesa</T>}
      <Box
        component="span"
        sx={{
          ml: 0.75,
          px: 1,
          py: 0.25,
          borderRadius: "999px",
          fontSize: "0.75rem",
          fontWeight: 700,
          lineHeight: 1.6,
          backgroundColor: liked ? alpha(filledText, 0.18) : alpha(brandColors.accent, 0.18),
        }}
      >
        {count}
      </Box>
    </Button>
  );
};

export default InterestButton;
